// extracted by mini-css-extract-plugin
module.exports = {"cardsBox":"ConcentrationMobile_cardsBox__1NkRW"};